import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import Modal from 'components/Modal'

import Input from 'components/Input'
import Button from 'components/Button'
import validateEmail from 'validators/email'
import { showErrorToast } from 'utils/toast'
import { requestAskChangeEmail } from 'api/user'
import EmailConfirmationModal from './EmailConfirmationModal'

const ChangeEmailModalForm = ({ toggleModal }) => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState({ field: '', error: '' })
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)

  const handleEmailChange = (e) => {
    setEmail(e.target.value)
  }

  const isFormValid = () => {

    if (!validateEmail(email)) {
      setError({ field: 'email', error: 'emailIsInvalid' })
      return false
    }

    setError({ field: '', error: '' })
    return true
  }

  const clearForm = () => {
    setEmail('')
    setShowConfirmationModal(true)
  }

  const submitForm = async () => {
    if (!isFormValid()) {
      return
    }
    setIsFormSubmitted(true)

    try {
      const response = await requestAskChangeEmail(email)
      if (response.error) {
        setError(response)
        setIsFormSubmitted(false)
      } else {
        setIsFormSubmitted(false)
        clearForm()
      }
    } catch (e) {
      showErrorToast(<FormattedMessage id='somethingWentWrong' />)
    }
  }

  return ( <>
    {<Modal isOpen={showConfirmationModal} toggleModal={setShowConfirmationModal} modalTitleId='emailConfirmation'>
      <EmailConfirmationModal />
    </Modal>}
    <Input
      field="email"
      value={email}
      label="email"
      onChange={handleEmailChange}
      placeholder="emailPlaceholder"
      error={error}
      dataTest='form-field'
      margin='0'
    />
    <div style={{ display: 'flex', justifyContent: 'flex-end'}}>
      <div style={{width: '95px'}}>
        <Button dataTest='cancel-button' marginTop='32px' type='secondary' onClick={() => {
          return toggleModal(false)
        }}>
          <FormattedMessage id='cancel' />
        </Button>
      </div>
      <div style={{ marginLeft: '16px' }}>
        <Button dataTest='submit' onClick={submitForm} marginTop='32px' isPending={isFormSubmitted} type='primary'>
          <FormattedMessage id='changeEmail' />
        </Button>
      </div>
    </div>
  </>
  )
}

export default ChangeEmailModalForm
